import React, { useState } from "react";
import api from "../utils/api";

const API = "https://mystockpicks.onrender.com";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        try {
            await api.post(`/api/auth/forgot`, { email });
            setDone(true); // generic success message
        } catch (e) {
            setDone(true); // still show generic message
        }
    };

    return (
        <div className="p-4 sm:p-6">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4 text-blue-400">Reset your password</h2>
            {done ? (
                <div className="text-green-400">
                    If an account with that email exists, we�ve sent a reset link. Please check your inbox.
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-3 max-w-md">
                    <input
                        type="email"
                        required
                        placeholder="you@example.com"
                        className="w-full p-3 rounded bg-gray-700 focus:outline-none"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    {err && <div className="text-red-400">{err}</div>}
                    <button className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-500 font-semibold">Send reset link</button>
                </form>
            )}
        </div>
    );
}
// JavaScript source code
